import {Component, ElementRef, OnInit, ViewChild, input} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-subscription-item-popup',
    templateUrl: './subscription-item-popup.component.html',
    styleUrls: ['./subscription-item-popup.component.scss'],
    standalone: false
})
export class SubscriptionItemPopupComponent implements OnInit {

  readonly subscriptionId = input<number>(undefined);
  @ViewChild('content', {static: true}) modal: ElementRef;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  open() {
    this.modalService.open(this.modal, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      console.log('close modal');
    }, (reason) => {

    });
  }

}
